/**
 * Labstep
 *
 * @module components/Device/Action/Create
 * @desc Create Action for Device
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { Device } from 'labstep-web/models/device.model';
import type React from 'react';
import type { DeviceActionCreateProps } from './types';

export const DeviceActionCreate: React.FC<
  DeviceActionCreateProps
> = ({ isTemplate }) => (
  <EntityActionCreate
    entityName={Device.entityName}
    body={isTemplate ? { is_template: true } : undefined}
    redirectRoute={({ response }) => ({
      to: 'device_show',
      params: { id: response.result },
    })}
    actionComponentProps={{
      type: 'button',
    }}
  />
);
